import React from 'react'

export default function BackendFooter() {
  return (
    <div className='footerblock'>
   Terms & Conditions Privacy Policy  Copyright@2022
   </div>
  )
}
